module.exports = __webpack_public_path__ + "static/media/Email.2b8a21aa.svg";